var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B94602BE-B77B-4065-AF4E-0013EABB681F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signup-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Signup-Flow-|-Select-League_FullLeagues_Confirmation-(Desktop)",
    transform: "translate(-544.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(327.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(217.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    transform: "translate(17.142857, 18.857143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 25.7142857,
    height: 25.7142857
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_checkmark_1740154",
    transform: "translate(0.000000, 2.571429)",
    fill: "#34A853",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1960333,0 C18.291808,3.91268985 13.799455,8.39332498 9.73984708,12.4561531 L3.20781834,6.89422248 L0,10.6841129 L8.27824087,17.7206176 L10.024453,19.2080934 L11.6412762,17.5783147 C16.0523369,13.1577755 21.2952366,7.93394056 25.7142857,3.50531762 L22.1960333,0 Z",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkTick);
export default __webpack_public_path__ + "static/media/ok-tick.887bb3e40c7e964631e400d2b6e337bb.svg";
export { ForwardRef as ReactComponent };